/*  MUI  */
import { DialogTitle } from '@mui/material';

/*  React  */
import React from 'react';

import { CloseButton } from './CloseButton';

export const ModalTitle = ({
    title,
    alignCenter,
    showClose = false,
    onClose,
    textTransform = 'capitalize',
    ...rest
}) => {
    const styles = {
        backgroundColor: 'modal.backgroundColor.title',
        color: 'modal.text.titleTextPrimary',
        fontWeight: 300,
        lineHeight: 1.5,
        padding: '16px 32px',
        textTransform
    };
    if (alignCenter) {
        styles.textAlign = 'center';
    }
    return (
        <DialogTitle sx={styles} {...rest}>
            {title}
            {showClose && (
                <CloseButton ariaLabel="closeButtonText" onClose={onClose} />
            )}
        </DialogTitle>
    );
};
